<template>
    <project-step-container
            prev-to="js_rapid_experiments_with_customers_16"
            :on-discard-project="redirection"
            :on-keep-version-project="redirection"
            @next-click="updateProject"
    >
        <b-row class="first-form">
            <b-col cols="12" class="simple-text"  tabindex="0">
                {{getMessage(17, 'rapidexperiment-sub')}}
            </b-col>
            <b-col cols="12" class="mt-4 simple-text-second" tabindex="0">
                {{getMessage(17, 'rapidexperiment-sub-text')}}
            </b-col>
        </b-row>
        <b-row class="mt-3">
            <b-col cols="12">
                <LinkStyleGuide :url="getMessage(17, isJACareerEntrepreApp ? 'rapidexperiment-link-new' : 'rapidexperiment-link')"
                                icon-name="icon-link" target="_blank"
                                :text="getMessage(17, 'rapidexperiment-link-text')"></LinkStyleGuide>
            </b-col>
        </b-row>
    </project-step-container>
</template>

<script>
    import ProjectStepContainer from "../../../core/Components/ProjectStepContainer"
    import LinkStyleGuide from "../../../core/Components/LinkStyleGuide"
    import {Steps} from "@/modules/JobShadow/Utils";
    import {ConflictSyn, Project} from "@/core/Utils";

    export default {
        name: "RapidExperimentsWithCustomers17",
        components: {ProjectStepContainer, LinkStyleGuide},
        data(){
            return{
                step:Steps.FORM_JS_RAPID_EXPERIMENTS_READY,
            }
        },
        methods:{
            updateProject() {
                const stepNumber = Steps.getStepFromForm(this.step)
                const index = this.$route.params.index
                Project.saveProjectStep(index, this.step, stepNumber, this.form, this.isOffline, this.isGuest).then(response => {
                    if (response.project?.hasDifferenceVersion) {
                        ConflictSyn.show(response.index, response.project)
                    } else {
                        this.redirection()
                    }
                }).catch(err => {
                    this.redirection()
                })
            },
            redirection(){
                const index = this.$route.params.index
                this.$router.push({name: 'js_rapid_experiments_with_customers_18', params: {index}})
            }
        }
    }
</script>

<style lang="stylus" scoped>
    @import "~@/core/Styles/variables.styl"
    @import "~@/core/Styles/mixins.styl"

    .simple-text-second
        font font-sourcesans-bold
        font-size 16px
        color color-4
</style>

